const BackToTop = () => {
    return <button className="back-to-top" style={{border:"0"}}><i className="lni-chevron-up"></i></button>;
};

export default BackToTop;